import axios from 'axios';

const getList = () => axios.get('/grupo-compras');
const get = id => axios.get(`/grupo-compras/${id}`);

export default {
  getList,
  get,
};
